
import { BrowserInfo } from "@/utils/browser";
import Vue from "vue";

export default Vue.extend({
	computed: {
		isWindows():boolean{
			const platform = navigator.platform;
			return platform.indexOf("Win") !== -1;
		},
		isMac():boolean{
			const platform = navigator.platform;
			return platform.indexOf("Mac") !== -1;
		},
		isElectron():boolean {
			return BrowserInfo.hasElectronConfigured();
		}
	},
	i18nEx: {
		componentPrefix: "views.TheLogin"
	},
});
